/** Management dashboard overview (`/dashboard/overview`). */
import { useQuery } from "@tanstack/react-query";
import { getData } from "../lib/apiClient";
import { queryKeys } from "./queryKeys";
import { DashboardOverview } from "../types/models";

export const dashboardApi = {
  overview: () => getData<DashboardOverview>("/dashboard/overview"),
};

export const useDashboardOverview = (enabled = true) =>
  useQuery({
    queryKey: queryKeys.dashboard.overview,
    queryFn: () => dashboardApi.overview(),
    enabled,
    refetchInterval: enabled ? 60_000 : false,
  });
